import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/settings/legal")({
  beforeLoad: ({ location }) => {
    throw redirect({
      to: "/settings/support",
      hash: location.hash || "legal-documents",
      replace: true,
    });
  },
});
